import { render, staticRenderFns } from "./suggestList.vue?vue&type=template&id=2cd06320&scoped=true&"
import script from "./suggestList.vue?vue&type=script&lang=js&"
export * from "./suggestList.vue?vue&type=script&lang=js&"
import style0 from "./suggestList.vue?vue&type=style&index=0&id=2cd06320&prod&lang=scss&scoped=true&"
import style1 from "./suggestList.vue?vue&type=style&index=1&id=2cd06320&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd06320",
  null
  
)

export default component.exports